import { createActionCreator } from 'deox';
import { TierReference, Tiers, StakeInformation as StakeInformation, TierIndex } from '../../types/reducerTypes';
import Big from 'big.js';

export const setStakedAmount = createActionCreator(
  'SET_STAKED_AMOUNT',
  (resolve) => (stakedAmount: Big) => resolve(stakedAmount),
);

export const setTierReference = createActionCreator(
  'SET_TIER_REFERENCE',
  (resolve) => (tierRef: TierReference) => resolve(tierRef),
);

export const setTier = createActionCreator('SET_STAKED_TIER', (resolve) => (tier: Tiers) => resolve(tier));

export const setTimeStaked = createActionCreator(
  'SET_TIME_STAKED',
  (resolve) => (timeStaked: string) => resolve(timeStaked),
);

export const setTimeUnlock = createActionCreator(
  'SET_TIME_UNLOCK',
  (resolve) => (timeUnlock: number) => resolve(timeUnlock),
);

export const setLockLevel = createActionCreator(
  'SET_LOCK_LEVEL',
  (resolve) => (lockLevel: string) => resolve(lockLevel),
);

export const setStakeInformation = createActionCreator(
  'SET_STAKE_INFORMATION',
  (resolve) => ({
    tierIndex,
    stakeInformation
  }: {
    tierIndex: TierIndex,
    stakeInformation: StakeInformation
  }) => resolve({ tierIndex, stakeInformation }),
);
